module.exports = __webpack_public_path__ + "static/media/about-us-top-illustration@2x.6e74687e.png";